import {normalizeMessarioOpenPeer} from '@lib/messarioLaunch/coordinatorCore';

export const MESSARIO_OPEN_PEER_KEY = 'messario_launch_open_peer';
export const MESSARIO_OPEN_PEER_EVENT = 'messario_open_peer';

export function saveMessarioOpenPeer(
  peer: string,
  storage: Storage = window.sessionStorage
) {
  const normalized = normalizeMessarioOpenPeer(peer);
  if(!normalized) {
    return;
  }

  storage.setItem(MESSARIO_OPEN_PEER_KEY, normalized);
  try {
    window.dispatchEvent(new CustomEvent(MESSARIO_OPEN_PEER_EVENT, {detail: normalized}));
  } catch(err) {
    // window may be unavailable in unit tests
  }
}

export function peekMessarioOpenPeer(
  storage: Storage = window.sessionStorage
): string | undefined {
  return normalizeMessarioOpenPeer(storage.getItem(MESSARIO_OPEN_PEER_KEY) || undefined);
}

export function consumeMessarioOpenPeer(
  storage: Storage = window.sessionStorage
): string | undefined {
  const peer = peekMessarioOpenPeer(storage);
  storage.removeItem(MESSARIO_OPEN_PEER_KEY);
  return peer;
}

export function messarioImHashForPeer(peer: string): string {
  return `#/im?p=${peer}`;
}
